module.exports = __webpack_public_path__ + "static/img/a.4a1640c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chat/a.png
// module id = 2rD0
// module chunks = 0